import React, { useEffect, useState } from "react";
import { Col, Row, DatePicker, Form, FormInstance, Input, Checkbox, Card, Tag } from 'antd';

import dayjs from 'dayjs';

import { disabledDate } from "../../../utils/utilsFunctions";
import { IAreaCertificadora, IcheckboxGroupOptions, ITipocertificado } from "./InterfaceCertificadoras";
import { maskNumeroProcesso } from "../../../utils/maskFunctions";
import { lista_areas_certificadoras } from "../../../config/Contantes";

type CheckboxValueType = string | number | boolean;

interface IProps {
  form: FormInstance<any>;
  setAreasCertificadoras: React.Dispatch<React.SetStateAction<IAreaCertificadora[]>>;
  areasCertificadoras: IAreaCertificadora[];
  tipoCertificados: ITipocertificado[];
  setDtCancelamentoIncluida: React.Dispatch<React.SetStateAction<boolean>>;
  loaded: boolean,
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const CertificadorasPerfil = ({ form, manter, setAreasCertificadoras, areasCertificadoras, tipoCertificados, setDtCancelamentoIncluida, loaded }: IProps) => {

  const [checkedAreasCertificadora, setCheckedAreasCertificadora] = useState<CheckboxValueType[]>([]);
  const [checkboxGroupOptions, setCheckboxGroupOptions] = useState<IcheckboxGroupOptions[]>(lista_areas_certificadoras);

  const carregarCheckBoxAreasMarcados = ()=>{
    //Quando a página carrega uma certificadora existente, é necessário marcar os checkbox delas. Os dados chegam em areasCertificadoras, mas costumam atrasar.
    setCheckedAreasCertificadora(
        areasCertificadoras.map((area: IAreaCertificadora) => {
          return area.csArea ? area.csArea.toString() : 0
        })
    )
  }

  useEffect(() => {
    if (loaded){
      carregarCheckBoxAreasMarcados();
    }
  }, [loaded]);

  useEffect(() => {
    if (manter !== 9) {
      // Não faz essa conferência para dados históricos.
      // As áreas em certificadoras que já foram selecionadas em tipos de certificados não podem ser desmarcadas, pois isso ficam desabilitadas.
      // Collect all csArea values from all tipoCertificados
      const disabledValues = tipoCertificados
        .flatMap(cert => cert.areas)
        .map(area => area.csArea?.toString());

      // Update checkboxGroupOptions with disabled flag
      const updatedOptions = checkboxGroupOptions.map(option => ({
        ...option,
        disabled: disabledValues.includes(option.value),
      }));

      setCheckboxGroupOptions(updatedOptions);
    }
  }, [tipoCertificados]);

  useEffect(() => {
    //Mudança no checkbox, exige atualizar a lista de áreas na memória
    
    const updatedAreas: IAreaCertificadora[] = checkedAreasCertificadora.map(csArea => {
      const existing = areasCertificadoras.find(area => area.csArea === csArea);
      if (existing) {
        return existing;
      }
      // If not found, create a new object with default values
      return {
        csArea,
        statusReg: 1,    // Example default status
        touched: true,
        emEdicao: manter === 3 ? true : false,
      };
    });
    setAreasCertificadoras(updatedAreas);
  }, [checkedAreasCertificadora]);

  const onChange = (checkedValues: CheckboxValueType[]) => {
    setCheckedAreasCertificadora(checkedValues);
  };

  return (
    <>
      <Row>
        <Col xs={24} sm={2} style={{ display: manter === 1 ? 'none' : 'inline' }}>
          <Form.Item label='Situação'
            colon={false}
          >
            <Tag color={form?.getFieldValue("canceladoNaBase") ? "volcano" : "geekblue"} >
              {form?.getFieldValue("canceladoNaBase") ? "INATIVO" : "ATIVO"}
            </Tag>
          </Form.Item>
        </Col>

        <Col xs={24} sm={6}>
          <Form.Item label='Número do Processo'
            name='nuProcesso'
            colon={false}
            rules={[
              {
                required: true,
                message: "Digite um número válido",
              },
            ]}
          >
            <Input
              disabled={manter === 2 || manter === 9 ? true : false}
              onChange={(e) => {
                form.setFieldsValue({
                  nuProcesso: maskNumeroProcesso(e.target.value)
                })
              }}
              maxLength={20}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={6}>
          <Form.Item label="Data do Reconhecimento"
            name="dtReconhecimento"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },

            ]}
          >
            <DatePicker
              disabled={manter === 2 || manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
              disabledDate={disabledDate}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={6} style={{ display: manter && manter >= 2 ? 'inline' : 'none' }}>
          <Form.Item label="Data do Cancelamento"
            name="dtCancelamento"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                validator: async (_, endDatetime) => {
                  const startDatetime = dayjs(form.getFieldValue("dtReconhecimento"));
                  if (endDatetime) {
                    if (endDatetime < startDatetime) {
                      return Promise.reject(
                        "Data de cancelamento deve ser maior ou igual à data de reconhecimento da certificadora"
                      );
                    }
                  }
                },
              },
            ]}
          >
            <DatePicker
              // onChange={() => { setDtCancelamentoIncluida(true) }}
              onChange={(date, dateString) => {
                if (dateString === "") {
                  setDtCancelamentoIncluida(false)
                } else {
                  setDtCancelamentoIncluida(true)
                }
              }}
              disabled={manter === 2 || manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
              disabledDate={disabledDate}
            />
          </Form.Item>
        </Col>

      </Row>

      <Card title={"Áreas de Atuação"}>
        <Checkbox.Group disabled={manter === 2 || manter === 9 ? true : false} options={checkboxGroupOptions} value={checkedAreasCertificadora} onChange={onChange} />
      </Card>

    </>
  )
};

export default CertificadorasPerfil;